export const enableMocking = async () => {
  if (import.meta.env.MODE !== 'development' || import.meta.env.VITE_DISABLE_MOCKING === 'true') {
    return
  }
  const { worker }: { worker: { start: () => void } } = await import('./mock/browser.ts')
  return worker.start()
}
